var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3672 0.365918C15.8555 -0.121973 16.6445 -0.121973 17.1328 0.365918C17.6211 0.854199 17.6211 1.64561 17.1328 2.13389L10.5195 8.71475L17.1328 15.3671C17.6211 15.8554 17.6211 16.6444 17.1328 17.1327C16.6445 17.621 15.8555 17.621 15.3672 17.1327L8.71484 10.5194L2.13398 17.1327C1.6457 17.621 0.854297 17.621 0.366094 17.1327C-0.122031 16.6444 -0.122031 15.8554 0.366094 15.3671L6.98047 8.71475L0.366094 2.13389C-0.122031 1.64561 -0.122031 0.854199 0.366094 0.365918C0.854297 -0.121973 1.6457 -0.121973 2.13398 0.365918L8.71484 6.98037L15.3672 0.365918Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.d46d80ac50e06911e66b1dda65f41152.svg";
export { ForwardRef as ReactComponent };